<template>	
	<div>
		<div class="condition">
			<div class="search_wrap">
				<el-form :inline="true"  :model="formdata" class="form-inline">
					<!-- <el-form-item label="支付编号">
						<el-input v-model="formdata.nickname" placeholder="支付编号" class="w80" size="small" ></el-input>
					</el-form-item> -->
					<el-form-item label="核销码">
						<el-input v-model="formdata.code" placeholder="请输入核销码" class="w200" size="small"></el-input>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input v-model="formdata.mobile" placeholder="请输入手机号" class="w200" size="small"></el-input>
					</el-form-item>
					<el-form-item label="活动名称">
						<el-input v-model="formdata.activity_title" placeholder="请输入活动名称" class="w200 " size="small"></el-input>
					</el-form-item>
					<el-form-item label="套餐"  >
						<el-select class="mr10 w130 taocan" v-model="formdata.sku_id" size="small" placeholder="请选择核套餐" style="width:100%">
							<el-option label="全部"  :value="0"></el-option>
							<el-option :label="item.sku_title| ellipsis" :value="item.sku_id" v-for="(item,index) in skuList" :key="index"></el-option>
						</el-select>              
					</el-form-item>
					<el-form-item label="核销状态">
						<el-select class="mr10 w130" v-model="formdata.status" size="small" placeholder="请选择核销状态">
							<el-option label="全部"  :value="0"></el-option>
							<el-option label="已核销" :value="2"></el-option>
							<el-option label="未核销" :value="1"></el-option>
						</el-select>              
					</el-form-item>
					<el-form-item label="佣金状态">
						<el-select class="mr10 w130" v-model="formdata.commission_status" size="small" placeholder="请选择佣金状态">
							<el-option label="全部"  :value="0"></el-option>
							<el-option label="成功" :value="1"></el-option>
							<el-option label="失败" :value="2"></el-option>
						</el-select>              
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker
							v-model="timeData"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							size="small"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							:picker-options="pickerOptions1"
						></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"  size="small" @click="searchcustomer">搜索</el-button>
						<el-button type="primary"  size="small" @click="excelOut">导出</el-button>
						<a ref="download" v-show="false" :href="downloadUrl" :download="downloadfilename"></a>
					</el-form-item>
				</el-form>
			</div>
			<!-- <div class="hexiao-btn"><el-button type="primary" size="small" icon="el-icon-edit"  @click="open()">核销</el-button></div> -->
		</div>
		<div class="table_wrap">
			<el-table :data="tableData" style="width: 100%">
				<!-- <el-table-column prop="id" label="编号" width="80px"></el-table-column> -->
			
				<!-- <el-table-column prop="nickname" label="微信昵称"></el-table-column> -->
				<el-table-column label="购买人" align="center" width="100px">
					<template slot-scope="scope">
						<img :src="scope.row.avatar" alt width="60px" height="60px" v-if="scope.row.avatar"/>
						<img src="@/assets/imgs/userDefult.png" altwu width="60px" height="60px" v-else/>
						<p>{{scope.row.nickname}}</p>
					</template>
				</el-table-column>
				<el-table-column label="购买人信息" width="160px">
					<template slot-scope="scope" >
						<div v-for="(item,index) in scope.row.buy_register_info" :key="index">
								<p>{{item.explain}}：{{item.value}}</p>
						</div>
						<el-link v-if="scope.row.pay_completion_info" type="primary" @click="onShowForm(scope.$index)">售后表单</el-link>
					</template>
				</el-table-column>
				
				<el-table-column prop="activity_title" label="活动名称">
					<div slot-scope="scope" >
						<span :title="scope.row.activity_title ">活动名称：{{scope.row.activity_title | ellipsis}}</span>
						<p>套餐名称：{{scope.row.sku_title | ellipsis}}</p>
					</div>
					<!-- <p>套餐名称：{{scope.row.sku_title}}</p> -->
				</el-table-column>
				<!-- <el-table-column prop="sku_title" label="购买价格套餐" width="110px"></el-table-column> -->
				<el-table-column prop="order_no" label="支付信息" >
					<div slot-scope="scope" >
						<p>购买金额：{{scope.row.sku_price}}</p>
						<p>支付编号：{{scope.row.order_no}}</p>
					</div>
				</el-table-column>
				<!-- <el-table-column prop="sku_price" label="购买金额" width="90px"></el-table-column> -->
			
				<el-table-column  label="邀请人" align="center" width="100px">
					<template slot-scope="scope">
						<img :src="scope.row.invitation_avatar" alt width="60px" height="60px" v-if="scope.row.invitation_avatar"/>
						<img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
						<p>{{scope.row.invitation_nickname}}</p>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="invitation_nickname" label="邀请人昵称"></el-table-column> -->
				<el-table-column prop="commission_res" label="分佣结果" width="110px"></el-table-column>
				
				<el-table-column prop="create_time" label="支付时间" width="110px">
					<div slot-scope="scope" >
						<span>{{scope.row.create_time.split(" ")[0]}}</span>
						<br>
						<span>{{scope.row.create_time.split(" ")[1]}}</span>
					</div>
				</el-table-column>
				<el-table-column prop="sms_res" label="短信发送结果" width="130px"></el-table-column>
				<!-- <el-table-column prop="verification_time_text" label="核销时间" >
					<div slot-scope="scope" >
						<span>{{scope.row.verification_time_text.split(" ")[0]}}</span>
						<br>
						<span>{{scope.row.verification_time_text.split(" ")[1]}}</span>
					</div>
				</el-table-column> -->
				<el-table-column prop="verification_text" label="核销信息"  width="300px">
					<div slot-scope="scope" >
						<p>核销状态：{{scope.row.verification_text}} 
							<span v-if="scope.row.verification_time_text">（{{scope.row.verification_time_text}}）</span>
							</p>
						<p>核销码：{{scope.row.verification_code}}</p>
						<p>有效期：{{scope.row.verification_expire_text}}</p>
					</div>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="100px">
					<template slot-scope="scope">
						<p>
							<el-button type="primary" size="small" icon="el-icon-edit"  @click="open(scope.row.verification_code)" v-if="scope.row.verification_text=='未核销'">核销</el-button>
							<el-button type="primary" size="small"  @click="open(scope.row.verification_code)" disabled v-if="scope.row.verification_text=='已核销'">已核销</el-button>
						</p>
						<!-- <p style="margin-top:10px">
							<el-button type="primary" size="small"  @click="ReissueCommission(scope.row.id)"  v-if="scope.row.commission_status==2">重发佣金</el-button>
						</p> -->
					</template>
				</el-table-column> 
			</el-table>
			<div class="pag_wrap">
				<el-pagination
					background
					:page-size="page.page_size"
					:current-page="page.current_page"
					layout="total, prev, pager, next"
					:total="page.total_rows"
					@current-change="pageIndexChange"
				></el-pagination>
			</div>
		</div>
		<afterSalesForm :visible.sync="dialogForm" title="售后表单" :property="payData"></afterSalesForm>
	</div>
</template>

<script>
	import api from "@/api.js";
	import { pagination1 } from "@/util/util.js";
	import afterSalesForm from '@/components/tkdialog/afterSalesForm';
	export default {
		name: 'purchaselog',
		components: {
			afterSalesForm
		},
		filters: {//限制文本显示字数,超出部分用...代替
			ellipsis (value) {
				if (!value) return ''
				if (value.length > 10) {
					return value.slice(0,10) + '...'
				}
				return value
			}
		},
		data() {
		  return {
				showCommission:true,
				downloadUrl:'',
				downloadfilename:'',
				dialogForm: false,
				payData: null,
		    formdata: {
					mobile:'',
					activity_title:'',
					page: 1, // 	整型 	必填 	- 	- 	页码
					code: '', // 	核销码
					start_time: '',
					end_time: '',
					activity_id: '',
					status: 0,
					commission_status:0,
					is_excel_out: 0,
					sku_id:0
		    },
		    tabIndex: 0,
			timeData: [],
			skuList:[],//套餐列表
		    tableData: [],
				page: {
					current_page: pagination1.current_page,
					page_size: pagination1.page_size,
					total_rows: pagination1.total_rows
				},
		    pickerOptions1: {
		      disabledDate(time) {
		        return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
		      }
		    }
		  };
		},
		created() {
			this.formdata.activity_id = this.$route.query.id || "";
		  this.init();
		},
		methods: {
		  //初始化请求
		  init() {
		    this.querycustom();
			},
			//重发佣金
			ReissueCommission(option){
				let id = parseInt(option)
				let data ={id: id}
				this.axios
					.post(api.reissueCommission, data)
					.then(response => {
						if (response.data.code == 0) {
							this.$message.success(response.data.msg);
							this.querycustom()
						} 
					})
					.catch(() => {});
			},
		
		  // 查询
		  querycustom() {
		    if (this.timeData && this.timeData.length > 0) {
		      this.formdata.start_time = this.timeData[0]
		      this.formdata.end_time = this.timeData[1]
		    } else {
		      this.formdata.start_time = ""
		      this.formdata.end_time = ""
			}
			// this.formdata.is_excel_out = 3
		    this.axios
					.post(api.getBuyLog, this.formdata)
					.then(response => {
						if (response.data.code == 0) {
							this.skuList = response.data.result.sku_list
							this.tableData = response.data.result.list;
							this.page = response.data.page;
						} 
					})
					.catch(() => {});
			},
		  searchcustomer() {
		    this.formdata.page = 1;
		    this.querycustom();
		  },
		  pageIndexChange(pageindex) {
		    this.formdata.page = pageindex;
		    this.querycustom();
			},
			//核销弹框
			open(value){
				console.log('核销码',value)
				// this.$prompt('核销购买商品', '请输入核销码', {
        //   confirmButtonText: '核销',
        //   cancelButtonText: '取消',
    
				// })
				this.$confirm('是否确定核销?（核销码：'+ value +'）', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
					})
				.then(() => {
					this.axios
						.post(api.setVerificationStatus,{code:value})
						.then(res=>{
							if(res.data.code == 0){
								this.$message.success(res.data.msg);
								setTimeout(()=>{   //设置延迟执行
									location.reload()
								},2000);
							}
						}).catch(res => {});
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消核销'
          });       
        });
			},
			//导出excel
			excelOut(){
			  this.$confirm('是否确认导出Excel?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
					this.formdata.is_excel_out = 1
					this.axios
						.post(api.getBuyLog,this.formdata)
						.then(res=>{
							if(res.data.code ==0 && res.data.result.excel_data !=''){
								this.downloadUrl = res.data.result.excel_data;
								this.downloadfilename = res.data.result.excel_filename;
								setTimeout(() => {
									this.$refs.download.click()
								}, 200)
							}
						}).catch(() => {})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          });          
        });
			},
			onShowForm(option) {
				this.payData = this.tableData[option].pay_completion_info			
				this.dialogForm = true
			}
		}
	}
</script>

<style scoped>
.condition .el-form-item{margin-bottom: 10px;}
</style>